<div class="d-flex align-items-center g-2">
  <p class="lead-details-title-text nowrap {{ textSize }}" data-id="lead-title-from">{{ from }}</p>
  @switch (type) {
    @case (portalTripType.Round) {
      <img
        data-id="lead-title-icon"
        class="lead-details-title-icon  {{ textSize }}"
        src="assets/icons/sync_alt.svg"
        alt="sync"
      />
    }
    @case (portalTripType.Multi) {
      <p class="lead-details-title-text text-ellipsis {{ textSize }}" data-id="lead-title-multi">
        (Multi-city)
      </p>
    }
    @default {
      <img
        data-id="lead-title-icon"
        class="lead-details-title-icon  {{ textSize }}"
        src="assets/icons/arrow_right_alt.svg"
        alt="arrow_right"
      />
    }
  }
  @if (type !== portalTripType.Multi) {
    <p class="lead-details-title-text text-ellipsis {{ textSize }}" data-id="lead-title-to">
      {{ to }}
    </p>
  }
</div>
